import * as types from './types';
import {
  SchoolAdminToolBookStatementClassCourseList,//教材计划列表
  SchoolAdminToolBookStatementClassList,//结算班级列表
  SchoolAdminToolBookStatementBookDiscount,//统一设置折扣
  SchoolAdminToolBookStatementBookCatalogCreate,//编辑教材计划列表书目
  SchoolAdminToolBookStatementClassCourseDelete,//删除教材计划列表书目
  SchoolAdminToolDataImportList,//数据导入列表
  SchoolAdminToolDataImportDelete,//数据导入删除
  SchoolAdminToolDataImportModel,//数据导入接口
  AdminToolChangeBookStatementBookCatalogList,//课程用书列表
  ToolBookStatementClassStudentListModel,//班级学生信息列表
  ToolBookStatementClassStudentBookSelectModel,//学生选书接口
  SchoolAdminToolBookStatementCourseTypeList,//课程类型列表
  AdminToolBookClassStatementNameModel,//编辑班级
  AdminToolDataImportProcessDetail,//导入进度查询
  ToolBookStatementCollegeListModel,//学院列表
  PublisherToolBookStatementStudentEditModel,//学生编辑
  PublisherToolBookStatementStudentChangeClassModel,//学生转班
  PublisherToolBookStatementClassCreateModel,//创建班级
  ToolBookStatementQrCodeModel,//刷新二维码
  ToolBookStatementBookCatalogDeleteDuplicateModel,//图书去重 #
  ToolBookStatementProvidersChangeModel,//图书更换供应商
} from 'src/model/AdminModel';
import {
  extend
} from 'lodash';

export default{
  //教材计划列表
  actionSchoolAdminToolBookStatementClassCourseList({commit, state}, query){
    if (state.schoolAdminToolBookStatementClassCourseList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_COURSE_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolBookStatementClassCourseList.getInstance().execute(query).then((response) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_COURSE_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_COURSE_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

  //结算班级列表
  actionSchoolAdminToolBookStatementClassList({commit, state}, query){
    if(query.noCommit){
      return SchoolAdminToolBookStatementClassList.getInstance().execute(query).then((response)=>{
        return response
      })
    }else{
      if (state.schoolAdminToolBookStatementClassList === 'loading'){
        return Promise.reject();
      }
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_LIST, {
        state: 'loading'
      });
      return SchoolAdminToolBookStatementClassList.getInstance().execute(query).then((response) => {
        commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_LIST, {
          ...response,
          state: 'loadend',
          'list': response.list
        });
        return response;
      }).catch((err) => {
        commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_LIST, {
          state: 'loaderr'
        });
        return Promise.reject(err);
      });
    }

  },
  //刷新二维码
  actionToolBookStatementQrCodeModel({commit, state}, query){
    return ToolBookStatementQrCodeModel.getInstance().execute(query);
  },
  //统一设置折扣
  actionSchoolAdminToolBookStatementBookDiscount({commit, state}, query){
    return SchoolAdminToolBookStatementBookDiscount.getInstance().execute(query);
  },
  //编辑教材计划列表书目
  actionSchoolAdminToolBookStatementBookCatalogCreate({commit, state}, query){
    return SchoolAdminToolBookStatementBookCatalogCreate.getInstance().execute(query);
  },
  //删除教材计划列表书目
  actionSchoolAdminToolBookStatementClassCourseDelete({commit, state}, query){
    return SchoolAdminToolBookStatementClassCourseDelete.getInstance().execute(query);
  },
  //数据导入列表
  actionSchoolAdminToolDataImportList({commit, state}, query){
    if (state.schoolAdminToolDataImportList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_SCHOOL_ADMIN_TOOL_DATA_IMPORT_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolDataImportList.getInstance().execute(query).then((response) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_DATA_IMPORT_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_DATA_IMPORT_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  //数据导入删除
  actionSchoolAdminToolDataImportDelete({commit, state}, query){
    return SchoolAdminToolDataImportDelete.getInstance().execute(query);
  },
  actionSchoolAdminToolDataImportModel({commit, state}, query){
    return SchoolAdminToolDataImportModel.getInstance().execute(query);
  },
  //课程用书列表
  actionSchoolAdminToolBookStatementBookCatalog({commit, state}, query){
    if (state.schoolAdminToolBookStatementBookCatalog === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_BOOK_CATALOG, {
      state: 'loading'
    });
    return AdminToolChangeBookStatementBookCatalogList.getInstance().execute(query).then((response) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_BOOK_CATALOG, {
        state: 'loadend',
        list: response.list,
        total:response.total
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_BOOK_CATALOG, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  actionGetClassStudentMassageListPortModel({commit,state},query){
    if (state.classStudentMassageList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_GET_CLASS_STUDENT_MASSAGE_LIST_PORT_MODEL, {
      state: 'loading'
    });
    return ToolBookStatementClassStudentListModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_GET_CLASS_STUDENT_MASSAGE_LIST_PORT_MODEL, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_GET_CLASS_STUDENT_MASSAGE_LIST_PORT_MODEL, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  //学生选书提交接口
  actionSubmitStudentSelectBookIdPort({commit,state},query){
    return ToolBookStatementClassStudentBookSelectModel.getInstance().execute(query);
  },
  //课程类型列表
  actionSchoolAdminToolBookStatementCourseTypeList({commit, state}, query){
    if (state.schoolAdminToolBookStatementCourseTypeList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_COURSE_TYPE_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolBookStatementCourseTypeList.getInstance().execute(query).then((response) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_COURSE_TYPE_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_COURSE_TYPE_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  //编辑班级
  actionAdminToolBookClassStatementNameModel({commit, state}, query){
    return AdminToolBookClassStatementNameModel.getInstance().execute(query);
  },
  //数据导入进度查询
  actionAdminToolDataImportProcessDetail({commit, state}, query){
    if (state.toolDataImportProcessDetail.state === 'loading') {
      return Promise.reject();
    }
    let resState = {
      state: 'loading'
    };
    if (state.toolDataImportProcessDetail.id == query.data_import_id) {
      resState = extend({}, state.toolDataImportProcessDetail, resState);
    }
    commit(types.ACTION_ADMIN_TOOL_DATA_IMPORT_PROCESS_DETAIL, resState);
    return AdminToolDataImportProcessDetail.getInstance().execute(query).then((response) => {
      commit(types.ACTION_ADMIN_TOOL_DATA_IMPORT_PROCESS_DETAIL, {
        ...response,
        state: 'loadend',
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_ADMIN_TOOL_DATA_IMPORT_PROCESS_DETAIL, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  actionSettleAccountsCollegeListPort({commit,state},query){
    if(state.settleAccountsCollegeList.state==='loading'){
      return new Promise.reject()
    }
    commit(types.ACTION_SETTLE_ACCOUNTS_COLLEGE_LIST_PORT,{
      state:'loading'
    });
    return  ToolBookStatementCollegeListModel.getInstance().execute(query).then(function (result) {
      commit(types.ACTION_SETTLE_ACCOUNTS_COLLEGE_LIST_PORT,{
        list:result.list,
        total:result.total,
        state:'loadend'
      })
    }).catch((err)=>{
      commit(types.ACTION_SETTLE_ACCOUNTS_COLLEGE_LIST_PORT,{
        state: 'loaderr'
      });
      return new Promise.reject(err)
    })
  },
  //学生编辑
  actionToolBookStatementStudentEditModel({commit,state},query){
    return PublisherToolBookStatementStudentEditModel.getInstance().execute(query);
  },
  //学生转班
  actionToolBookStatementStudentChangeClassModel({commit,state},query){
    return PublisherToolBookStatementStudentChangeClassModel.getInstance().execute(query);
  },
  //创建班级
  actionCreateClassModelPort({commit,state},query){
    return PublisherToolBookStatementClassCreateModel.getInstance().execute(query);
  },
  //改变班级
  actionChangeClassListOfBatch({commit},query){
    commit(types.ACTION_CHANGE_CLASS_LIST_OF_BATCH, query)
  },
  //图书去重 #
  actionToolBooksScreenUnnecessaryTextbook({commit},query){
    return ToolBookStatementBookCatalogDeleteDuplicateModel.getInstance().execute(query);
  },
  //图书更换供应商
  actionToolBookStatementProviderChange(store,query){
    return ToolBookStatementProvidersChangeModel.getInstance().execute(query);
  },
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/textBookSchedule/actions.js